import { safeRedirectPath } from "modules/members/safeRedirect";

// A same-tab sign-in leaves the portal for the provider and comes back on the
// success page, so the page a link pointed at has to outlive the round trip.
const KEY = "memberReturnPath";

// Storage can throw (full, or blocked); losing the destination must never
// stop the sign-in itself.
export const rememberReturnPath = (path: string | null) => {
  try {
    if (path) sessionStorage.setItem(KEY, path);
    else sessionStorage.removeItem(KEY);
  } catch {}
};

/** The remembered page, if it is a safe in-app path. Read once. */
export const takeReturnPath = () => {
  try {
    const path = safeRedirectPath(sessionStorage.getItem(KEY));
    sessionStorage.removeItem(KEY);
    return path;
  } catch {
    return null;
  }
};
